// Angular Core
import { Injectable } from '@angular/core';

// Interfaces
import { FormControlStructure } from '../../interfaces/FormControlStructure';
import { InputValidator } from '../../interfaces/GenericInputConfigs';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {
  getValidators(controlName: string, formControls: FormControlStructure[]): InputValidator | undefined {
    let control = formControls.find((control: FormControlStructure) => control.controlName === controlName)

    if(control) {
      if(control.validators && control.validatorsMessages) {
        return {
          validators: control.validators,
          errorMessages: control.validatorsMessages
        }
      }
    }

    return undefined
    }
}
